/* * 地图图层点击事件 -视频弹框 * @module components/mapbase/MapToolTip * @desc 用于地图弹框显示 *
@author zhaoting * @date 2019年12月19日 * @param {Boolean} [modal1] - 是否显示 * @param {String}
[videourl] - 视频播放地址 */
<script>
export default {
  name: 'MapVideoTip',
  components: {},
  props: {
    videourl: {
      type: String,
      default: '',
    },
    modal1: {
      type: Boolean,
      default: '',
    },
  },
  data() {
    return {
      map: {},
    };
  },
  mounted() {
    // 视频播放
    this.initInfo();
    // videojs('my-video', function() {
    //   this.play();
    // });
  },
  created() {
    //    this.configmap = config.map;
  },
  methods: {
    initInfo() {
      //      this.videourl =
    },
    ok() {
      this.$emit('childFn', false);
    },
    cancel() {
      this.$emit('childFn', false);
    },
  },
};
</script>

<template>
  <div class="mapvideo">
    <Modal 
      v-model="modal1" 
      title="视频播放" @on-ok="ok" @on-cancel="cancel" :mask="false">
      <!-- <video width="100%" height="260px"  controls="controls" autobuffer="autobuffer"  autoplay="autoplay" loop="loop">
        <source src="http://192.168.30.212:20000/hls/1000222.m3u8" type="video/mp4"></source>
      </video> -->
      <video
        id="my-video"
        class="video-js vjs-default-skin box"
        controls
        preload="auto"
        width="490px"
        height="260px"
      >
        <source 
src="http://192.168.30.212:20000/hls/1000222.m3u8" type="application/x-mpegURL" />
      </video>
    </Modal>
  </div>
</template>
<style lang="less" scoped>
.video-js .vjs-big-play-button {
  top: 40% !important;
  left: 40% !important;
}
</style>



// WEBPACK FOOTER //
// src/components/mapbase/MapVideoTip.vue